module.exports = __webpack_public_path__ + "static/img/B.9701fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/B.png
// module id = 8jY2
// module chunks = 0